import React from 'react'
import Layout from '../../Components/Layout'
import BannerGlobal from '../../Components/BannerGlobal'
import BrandLogos from '../../Components/BrandLogos'
import CaseStudy from '../../Components/CaseStudy'
import useDocumentTitle from '../../Hooks/PageTitle'

const ProjectsPage = () => {
  useDocumentTitle("TRoo Construction | Projects")
  return (
    <Layout>
        <BannerGlobal/>
        <CaseStudy isCaseStudyPage/>
        <BrandLogos/>
    </Layout>
  )
}

export default ProjectsPage